// extracted by mini-css-extract-plugin
export default {"tooltip":"style_tooltip__zHGMI","right":"style_right__460GK","left":"style_left__EEMGt","top":"style_top__pWBtL","bottom":"style_bottom__wSJ4k"};